
import React, { useEffect, useState, Suspense } from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { formatPriceBR, formatDateBR } from '../../util';
import { incluirNoEstoque } from '../../redux/reducers/vitrineSlice';
import InputMask from 'react-input-mask';
import {
    fetchProposals,
    updateProposalStatus,
    setCurrentPage,
    setSearchTerm,
    setSortDirection,
    clearUpdatedProposalId,
    clearMessages,
} from '../../redux/reducers/propostaSlice';
import Loader from '../../components/loading';
const QuillEditor = React.lazy(() => import('../../../src/config/QuilEditor'));
const PaginationComponent = React.lazy(() => import('../../components/paginacao'));

const Proposta = () => {
    const dispatch = useDispatch();
    // Estados no slice
    const {
        items,
        totalItems,
        currentPage,
        itemsPerPage,
        loading,
        error,
        successMessage,
        searchTerm,
        sortDirection,
        updatedProposalId,
    } = useSelector((state) => state.proposals);
    const {
        loading2,
        message,
        error2
    } = useSelector((state) => state.vitrini)
    // Estados locais para o Modal
    const [showModal, setShowModal] = useState(false);
    const [showModalStatus, setShowModalStatus] = useState(false);
    const [selectedProposal, setSelectedProposal] = useState(null);
    // Campos para atualizar status
    const [status, setStatus] = useState('');
    const [sendCode, setSendCode] = useState('');
    const [newValor, setNewValor] = useState('');
    const [custoFrete, setCustoFrete] = useState('');
    const [codigoDev, setCodigoDev] = useState('');
    const [dataPag, setDataPag] = useState('');
    const [rejectionReason, setRejectionReason] = useState('');
    // Estados locais que “espelham” ou unificam esses valores
    const [combinedLoading, setCombinedLoading] = useState(false);
    const [combinedError, setCombinedError] = useState(null);
    const [combinedSuccessMessage, setCombinedSuccessMessage] = useState(null);
    //Variaveis selecinadas
    const [conexao, setConexao] = useState(null)
    const [cor, setCor] = useState(null)
    const [capacidade, setCapacidade] = useState(null)
    //Dados Bancários
    const [bankName, setBankName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [agencyNumber, setAgencyNumber] = useState('');
    // ======= UseEffects =======
    // (1) Carrega as propostas ao montar o componente (ou quando muda currentPage/searchTerm/sortDirection)
    useEffect(() => {
        dispatch(fetchProposals({ page: currentPage, searchTerm, sortDirection }));
    }, [dispatch, currentPage, searchTerm, sortDirection]);

    // (2) Se houve update, focar na linha da tabela do proposal atualizado
    useEffect(() => {
        if (updatedProposalId) {
            const rowElement = document.getElementById(`proposal-${updatedProposalId}`);
            if (rowElement) {
                // 1) Rolagem manual (sem "smooth" nativo)
                const rect = rowElement.getBoundingClientRect();
                const offset = rect.top + window.scrollY - 100; // -100 pra deixar um espaçamento no topo
                window.scrollTo({
                    top: offset,
                    left: 0,
                });
                // 2) Destaque visual via classe (com !important)
                rowElement.classList.add('row-highlight');
                setTimeout(() => {
                    rowElement.classList.remove('row-highlight');
                }, 8000);
            }
            dispatch(clearUpdatedProposalId()); // se quiser limpar o ID já aqui
        }
    }, [updatedProposalId, dispatch]);
    // Sempre que loading ou loading2 mudar, atualiza o estado local
    useEffect(() => {
        // Exemplo: se qualquer loading estiver true, combinedLoading é true
        setCombinedLoading(loading || loading2);
    }, [loading, loading2]);
    // Sempre que error ou error2 mudar, atualiza o estado local
    useEffect(() => {
        // Exemplo: exibe prioridade para error2 ou qualquer um que não seja null
        if (error2) {
            setCombinedError(error2);
        } else if (error) {
            setCombinedError(error);
        } else {
            setCombinedError(null);
        }
    }, [error, error2]);
    // Sempre que successMessage ou message mudar, atualiza
    useEffect(() => {
        // Exemplo: se message existir, exibe; senão, usa successMessage
        if (message) {
            setCombinedSuccessMessage(message);
        } else if (successMessage) {
            setCombinedSuccessMessage(successMessage);
        } else {
            setCombinedSuccessMessage(null);
        }
    }, [successMessage, message]);
    // ======= Handlers =======
    // 1. Fechar alert de erro/sucesso
    const handleCloseAlert = () => {
        dispatch(clearMessages());
    };
    // 2. Paginação
    const handlePageChange = (newPage) => {
        dispatch(setCurrentPage(newPage));
    };
    // 3. Atualizar status (modal -> dispatch thunk)
    const handleUpdateStatus = () => {
        const payload = {
            proposalId: selectedProposal.id,
            status,
            codigo: sendCode,
            rejectionReason,
            newValor,
            custoFrete,
            dataPag,
            codigoDev,
        };

        dispatch(updateProposalStatus(payload))
            .unwrap()
            .then(() => {
                // Se quiser fechar modal somente se deu certo
                setShowModalStatus(false);
                setShowModal(false);
            })
            .catch(() => {
                // Se quiser tratar erro ou manter modal aberto
            });
    };
    // 4. Abrir modal de visualização
    const handleViewDetails = (proposal) => {
        setSelectedProposal(proposal);
        // console.log(proposal,'handleViewDetails')
        setShowModal(true);
    };
    // 5. Abrir modal de update de status
    const handleStatusChange = (proposal) => {
        setSelectedProposal(proposal);
        setShowModalStatus(true);
        // Resetar campos
        setStatus('');
        setSendCode('');
        setNewValor('');
        setCustoFrete('');
        setCodigoDev('');
        setDataPag('');
        setRejectionReason('');
    };
    // 6. Ordenar (asc/desc)
    const handleSort = () => {
        const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        dispatch(setSortDirection(newDirection));
    };
    // 7. Buscar por código ou nome
    const handleSearch = (e) => {
        dispatch(setSearchTerm(e.target.value));
    };
    // Função de status textual (você pode melhorar de acordo com seu backend)
    const getTextoTabela = (statusValue) => {
        switch (Number(statusValue)) {
            case 4:
                return 'Código enviado';
            case 5:
                return 'Em trânsito';
            case 6:
                return 'Venda aprovada';
            case 7:
                return 'Venda reprovada';
            case 8:
                return 'Contraproposta enviada';
            case 9:
                return 'Contraproposta aprovada';
            case 10:
                return 'Produto devolvido';
            case 11:
                return 'Venda cancelada';
            default:
                return 'Aguardando';
        }
    };
    // ======= Render =======
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const handleIncluirNoEstoque = (proposal) => {
        // console.log(proposal)
        dispatch(incluirNoEstoque(proposal)); // Enviar dados para o Redux
    };
    useEffect(() => {
        if (selectedProposal?.bank_data) {
            const jsonData = JSON.parse(selectedProposal?.bank_data);
            setBankName(jsonData.bank_name);
            setAccountNumber(jsonData.account_number);
            setAgencyNumber(jsonData.agency_number);
        }
        let conexaoEncontrada = false;
        let corEncontrada = false;
        let capacidadeEncontrada = false;
        // Itera sobre o array principal
        selectedProposal?.selected_options?.forEach((option) => {
            if (option.atributo === "Conexão" && Array.isArray(option.items)) {
                conexaoEncontrada = true;
                // Atualiza o estado com o valor encontrado
                setConexao(option.items[0]?.value || null); // Primeiro valor ou null
            }
            if (option.atributo === "Capacidade" && Array.isArray(option.items)) {
                capacidadeEncontrada = true;
                setCapacidade(option.items[0]?.value || null);
            }
            if (option.atributo === "Cores" && Array.isArray(option.items)) {
                corEncontrada = true;
                setCor(option.items[0]?.value || null);
            }
        });
        // Redefine o estado se o atributo não foi encontrado
        if (!conexaoEncontrada) setConexao(null);
        if (!capacidadeEncontrada) setCapacidade(null);
        if (!corEncontrada) setCor(null);

    }, [selectedProposal]);
    const handleEditorReproChange = (newValue) => {
        setRejectionReason(newValue);
    };
    return (
        <Container>
            <h2 className="text-center mb-4 titulo-modal titulo-pagina"><i style={{color:'#ff7a00'}} class="fas fa-file-invoice mr-3"></i>  Pedido de Compras</h2>
            {/* Alerts de erro e sucesso */}
            {combinedSuccessMessage && (
                <Alert variant="success" onClose={handleCloseAlert} dismissible className='text-center'>
                    {combinedSuccessMessage}
                </Alert>
            )}
            {combinedError && (
                <Alert variant="danger" onClose={handleCloseAlert} dismissible className='text-center'>
                    {combinedError}
                </Alert>
            )}

            {/* Campo de busca */}
            <div className="mb-3 d-flex justify-content-end align-items-center">
                <div className="position-relative" style={{ maxWidth: '300px' }}>
                    <Form.Control
                        type="text"
                        placeholder="Buscar por ID ou nome..."
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{ paddingRight: '2rem', backgroundColor: '#fff' }} // Cor de fundo do campo
                    />
                    {/* Exibe o ícone somente se existir texto */}
                    {searchTerm && (
                        <i
                            className="fa-solid fa-xmark"
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: '10px',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: '#888', // Ajuste a cor se quiser
                            }}
                            onClick={() => handleSearch({ target: { value: '' } })}
                        // ou dispatch(setSearchTerm('')) se estiver usando Redux
                        />
                    )}
                </div>
                <Button variant="secondary" onClick={handleSort} className="p-1 ms-2">
                    Ordenar
                    {sortDirection === 'asc' ? (
                        <i className="fa-solid fa-sort-up p-2"></i>
                    ) : (
                        <i className="fa-solid fa-sort-down p-2"></i>
                    )}
                </Button>
            </div>
            {/* Paginação */}
            <div className='d-flex justify-content-center'>
                <Suspense>
                    <PaginationComponent
                        currentPage={currentPage}
                        lastPage={totalPages}
                        onPageChange={handlePageChange}
                    />
                </Suspense>
            </div>
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={combinedLoading} />
                <Table  bordered hover responsive className="tabela-painel text-center" style={{ fontSize: '0.7em' }}>
                    <thead>
                        <tr className='cabecalho-tabela'>
                            <th>N° Pedido</th>
                            <th>Usuário</th>
                            <th>Data</th>
                            <th>Valor da Proposta</th>
                            <th>Status</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items?.length > 0 ? (
                            items.map((proposal) => {
                                const isUserDeleted = proposal.user?.deleted_at !== null; // Verifica se o usuário foi desativado

                                return (
                                    <tr key={proposal.id} id={`proposal-${proposal.id}`} className='celula-tabela'>
                                        <td >{proposal.id}</td>
                                        <td style={{ color: isUserDeleted ? 'red' : 'inherit' }}>
                                            {proposal.user?.name}
                                        </td>
                                        <td>{formatDateBR(proposal?.created_at)}</td>
                                        <td>{formatPriceBR(proposal.proposal_value)}</td>
                                        <td>{getTextoTabela(proposal.status)}</td>
                                        <td>
                                            <Button
                                                variant="info"
                                                size="sm"
                                                className="botao-acao visualizar"
                                                onClick={() => handleViewDetails(proposal)}
                                            >
                                                Visualizar
                                            </Button>
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                className="botao-acao alterar-status"
                                                onClick={() => handleStatusChange(proposal)}
                                                disabled={isUserDeleted} // Desativa se o usuário estiver desativado
                                            >
                                                Alterar Status
                                            </Button>
                                            <Button
                                                variant="success"
                                                size="sm"
                                                className="botao-acao incluir-estoque"
                                                onClick={() => handleIncluirNoEstoque(proposal)}
                                                disabled={proposal.status !== 6 || isUserDeleted} // Desativa se status for diferente de 6 ou usuário desativado
                                            >
                                                Incluir no Estoque
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5">Nenhuma proposta encontrada.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {/* Modal de Visualização */}
            <Modal className="modal-custom" show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Dados da Proposta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedProposal && (
                        <div className="mt-4">
                            <div className="info-modelo">
                                <h4>
                                    <span className="model-name">{selectedProposal?.modelo} {capacidade} {cor} {conexao}</span>
                                </h4>
                                <p>
                                    {formatPriceBR(selectedProposal?.proposal_value)}
                                </p>
                            </div>
                            {selectedProposal.selected_options.map((option, index) => (
                                <div className="box-option" key={index}>
                                    <label><strong>{option.atributo}</strong></label>
                                    <ul>
                                        {option.items.map((item, idx) => (
                                            <li key={idx}>
                                                <p>
                                                    <i className="fa-solid fa-check"></i>
                                                    <span className="option-value"> {item.value}</span>
                                                    <span className="peso" style={{ color: item.type === 'acrescimo' ? 'green' : 'red' }}>{formatPriceBR(item.peso)}</span>
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    )}
                    <hr />
                    <div className='box-option'>
                        <ul>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Marca:</strong> {selectedProposal?.marca}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Tipo:</strong> {selectedProposal?.tipo}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Modelo:</strong> {selectedProposal?.modelo}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>IMEI:</strong> {selectedProposal?.imei}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Número de Série:</strong> {selectedProposal?.serial_number}</span></p></li>
                        </ul>
                    </div>
                    <hr />
                    <div className='box-option'>
                        <h4 className='text-center pb-3' style={{ fontWeight: 700 }} >Informações Pessoais</h4>
                        <ul>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Nome:</strong> {selectedProposal?.user.name}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>RG:</strong> {selectedProposal?.user.rg}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Email:</strong> {selectedProposal?.user.email}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Endereço:</strong> {selectedProposal?.user?.address?.address} - N° {selectedProposal?.user?.address?.number} {selectedProposal?.user?.address?.complement} - {selectedProposal?.user?.address?.neighborhood} - {selectedProposal?.user?.address?.city} / {selectedProposal?.user?.address?.state} - {selectedProposal?.user?.address?.cep}</span></p></li>
                        </ul>
                    </div>
                    {selectedProposal?.bank_data && (
                        <div className='box-option'>
                            <h4 className='text-center' style={{ fontWeight: 700 }}>Dados Bancários</h4>
                            <ul>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>Nome:</strong> {selectedProposal?.user.name} </span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>Nome do Banco:</strong> {bankName}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>N° da Agência:</strong> {agencyNumber}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>N° da conta:</strong> {accountNumber}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value">
                                            <strong>CPF:</strong> {selectedProposal?.user.cpf}
                                        </span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    )}
                    <div className='box-option'>
                        <h4 className='text-center' style={{ fontWeight: 700 }}>Status da Avaliação</h4>
                        <ul>
                            {(selectedProposal?.status <= 3) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {selectedProposal?.codigo != null &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Código para Envio:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i> {selectedProposal?.codigo}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }

                        </ul>
                        <ul>
                            {(selectedProposal?.status === 5) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.status === 6) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {selectedProposal?.rejectionReason != null &&
                                (
                                    <div className="box-option">
                                        <h5><strong>Status Reprovado</strong></h5>
                                        <ul>
                                            <label><strong>Motivo:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>
                                                    <div
                                                        className="option-value"
                                                        dangerouslySetInnerHTML={{ __html: selectedProposal?.rejectionReason }}
                                                    />
                                                </p>
                                            </li>
                                            <label><strong>Novo Valor da Proposta:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  R$ {selectedProposal?.proposal_value_new}
                                                </p>
                                            </li>
                                            <label><strong>Custo Frete:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i> R$ {selectedProposal?.custo_frete}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {selectedProposal?.data_pagamento != null &&
                                (
                                    <div className="box-option">
                                        <h5><strong>Contraproposta</strong></h5>
                                        <ul>
                                            <label><strong>Data do Pagamento:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>{formatDateBR(selectedProposal?.data_pagamento)}</p>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.status === 9) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.codigo_dev != null) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Código para Devolução:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i> {selectedProposal?.codigo_dev}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.status === 11) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Modal para Alterar Status */}
            <Modal show={showModalStatus} onHide={() => setShowModalStatus(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Alterar Status da Proposta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedProposal && (
                        <Form>
                            <Form.Group>
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={status}
                                    onChange={(e) => setStatus(Number(e.target.value))}
                                >
                                    <option value="">Selecione</option>
                                    <option value="4">Inserir código de envio</option>
                                    <option value="5">Em trânsito</option>
                                    <option value="6">Aprovar Compra</option>
                                    <option value="7">Reprovar Compra</option>
                                    <option value="8">Enviar Contraproposta</option>
                                    <option value="9">Aprovar Contraproposta</option>
                                    <option value="10">Devolução</option>
                                    <option value="11">Cancelar Compra</option>
                                </Form.Control>
                            </Form.Group>

                            {status === 4 && (
                                <Form.Group className="mt-3">
                                    <Form.Label>Código de Envio</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Insira o código de envio"
                                        value={sendCode}
                                        onChange={(e) => setSendCode(e.target.value)}
                                    />
                                </Form.Group>
                            )}

                            {status === 7 && (
                                <Form.Group className="mt-3">
                                    <Form.Label>Motivo da Reprovação</Form.Label>
                                    <Suspense fallback={<div>Carregando editor...</div>}>
                                        <QuillEditor
                                            value={rejectionReason}
                                            onChange={handleEditorReproChange}
                                            uploadUrl={`${process.env.REACT_APP_API_URL}/upload-image`} // Correção aqui
                                            allowImages={false}
                                        />
                                    </Suspense>
                                    <Form.Label>Valor da Contraproposta</Form.Label>
                                    <input
                                        value={newValor}
                                        onChange={(event) => setNewValor(event.target.value || '')} // Correção aqui

                                        placeholder="R$ 0,00"
                                    />
                                    <Form.Label>Custo Frete</Form.Label>
                                    <input
                                        value={custoFrete}
                                        onChange={(event) => setCustoFrete(event.target.value || '')} // Correção aqui
                                        placeholder="R$ 0,00"
                                    />
                                </Form.Group>
                            )}

                            {status === 8 && (
                                <Form.Group className="mt-3">
                                    <Form.Group md="6" controlId="birthDate">
                                        <Form.Label className='mt-3'>Data Pagamento</Form.Label>
                                        <InputMask
                                            mask="99/99/9999" // Formato DD/MM/YYYY
                                            value={dataPag}
                                            onChange={(e) => setDataPag(e.target.value)}
                                            placeholder="DD/MM/AAAA"
                                        >
                                            {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                        </InputMask>
                                    </Form.Group>
                                </Form.Group>
                            )}

                            {status === 10 && (
                                <Form.Group className="mt-3">
                                    <Form.Label>Código de Devolução</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Insira o código de devolução"
                                        value={codigoDev}
                                        onChange={(e) => setCodigoDev(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalStatus(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleUpdateStatus}>
                        {loading ? 'Atualizando...' : 'Atualizar Status'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default Proposta;
